import React from 'react';

import { BranchIcon } from '../../icons/branch-icon';
import { BranchStartIcon } from '../../icons/branch-start-icon';

export const EventLoaderSkeleton = ({ count = 20 }) => {
  const CellLoader = () => (
    <td className="flex-1 py-2 pr-4 pl-2">
      <div className="h-5 animate-pulse bg-gray-200 rounded-md">&nbsp;</div>
    </td>
  );
  return (
    <>
      {new Array(count).fill(0).map((_, id) => (
        <tr
          key={id}
          data-testid={`skeleton-item overflow-visible ${id}`}
          className="relative my-2 h-[56px]"
        >
          <td className="p-2 pr-6 pl-2 leading-[18px] break-words truncate ">
            <div className="flex items-center min-h-[40px] ml-7 w-full">
              <div
                className={`absolute left-[30px] z-[10] ${
                  id === 0 ? 'top-[-18x]' : 'top-[-48px]'
                }`}
                style={{ pointerEvents: 'none' }}
              >
                {id === 0 ? <BranchStartIcon /> : <BranchIcon />}
              </div>
              <div className="ml-3 mr-4 flex w-full">
                <div className="h-[36px] min-w-[56px] animate-pulse bg-gray-200 mr-4 rounded-md">
                  &nbsp;
                </div>
                <div className="my-auto w-full">
                  <div className="h-5 animate-pulse bg-gray-200 rounded-md">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </td>

          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
        </tr>
      ))}
    </>
  );
};
